// Customer-facing AI API calls -> licenseportalapi /api/ai/*.
// Uses the shared axios instance, which already carries the customer JWT.
import axios from "src/utils/axios";

export const getMyAiUsage = () =>
  axios.get("/api/ai/me").then(r => r.data);

export const getAiOverview = () =>
  axios.get("/api/ai/overview").then(r => r.data);

export const getAiUsers = () =>
  axios.get("/api/ai/users").then(r => r.data);

export const setUserAiAllocation = (userId, body) =>
  axios.put(`/api/ai/users/${userId}/allocation`, body).then(r => r.data);

// Company-wide recent AI activity (metadata only; admin).
export const getAiActivity = (params) =>
  axios.get("/api/ai/activity", { params }).then(r => r.data);
